import React from 'react'
import './ActivOrders.css'
import OneOrder from './OneOrder'

const ActivOrders = ({listOfOrders, listOfDrivers}) => {
  
  return (
    <div className='activeOrdersContainer'>
        <h2>Objednávky</h2>
       {
            listOfOrders.map( (oneOrder) => {
                return <OneOrder key={oneOrder.keyOfClient} oneOrder={oneOrder} listOfDrivers={listOfDrivers}/>
            })
       }
    </div>
  )
}

export default ActivOrders
